import { Stack } from '@optimus-web/core';
import { SpacedPipe } from '@mews-commander/ui';

interface SpaceOrderNameProps {
    resourceName: string;
}

export const SpaceOrderName: React.FC<SpaceOrderNameProps> = ({ resourceName }) => (
    <Stack wrap>
        {resourceName ? (
            <>
                {resourceName}
                {SpacedPipe}
            </>
        ) : null}
    </Stack>
);
